import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  constructor(private http: HttpClient) { }

  getAnnouncementList(queryParams) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.GET_BROADCASTS_LIST, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  getAnnouncementById(id) {
    return this.http.get<any>(urls.BASE_URL  + urls.GET_BROADCASTS_LIST + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveAnnouncement(payload) {
    return this.http.post<any>(urls.BASE_URL + urls.GET_BROADCASTS_LIST, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
  
  updateAnnouncement(id:any, payload) {
    return this.http.put<any>(urls.BASE_URL + urls.GET_BROADCASTS_LIST + `/${id}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
}
